import { useState, useEffect } from 'react';
import { severity, useNotification } from '../../../components/Notification';
import { useNavigate } from 'react-router';
import { fetchData } from '../../../axios/fetchData';
import { SdpDashboardSettings } from '../types';
import { isDevMode } from '../../../utils/isDevMode';

export const useSdpDashboardSettings = () => {
  const { showMessage } = useNotification();
  const navigate = useNavigate();
  const [settings, setSettings] = useState<undefined | SdpDashboardSettings>(undefined);

  useEffect(() => {
    async function load() {
      const url = isDevMode()
        ? `${import.meta.env.VITE_APP_SDP_DASHBOARD}settings.json`
        : `${import.meta.env.VITE_APP_SDP_DASHBOARD}settings`;

      try {
        const result = await fetchData(
          {
            url,
            params: {
              _format: 'json',
            },
          },
          (message: string, type: severity) => {
            if (message !== 'Dashboard settings not found.') showMessage(message, type);
          },
          navigate,
        );

        if (result?.data) {
          setSettings(result.data as SdpDashboardSettings);
        }
      } catch (err) {
        console.error(`Error loading settings`, err);
      }
    }

    load();
  }, []);

  return { settings };
};
